import * as React from "react";

type ShuffleAction = "increment" | "decrement" | "reset";

export default function useShuffleIndex(
    length: number,
    initial = 0
): [number, (shuffleAction: ShuffleAction) => void] {
    const [currentIndex, setCurrentIndex] = React.useState(initial);

    const shuffle = (shuffleAction: ShuffleAction) => {
        switch (shuffleAction) {
            case "increment":
                setCurrentIndex((currentIndex + 1) % length);
                break;
            case "decrement":
                setCurrentIndex((currentIndex + (length - 1)) % length);
                break;
            case "reset":
                setCurrentIndex(initial);
                break;
            default:
                return;
        }
    };

    return [currentIndex, shuffle];
}
